export default {
  props: {
    sectionHeader: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedIndex: 0,
      // index of selected tab
      tabs: [] // all of the tab content
    };
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.selectTab(0);
  },
  methods: {
    selectTab(index) {
      this.selectedIndex = index;
      this.tabs.forEach((tab, tabIndex) => {
        tab.isActive = index === tabIndex;
      });
    }
  }
};